export default __webpack_public_path__ + "static/media/nocorevalues.4be56be1.png";